import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=2a1a1c50&"
import script from "./Favourite.vue?vue&type=script&lang=js&"
export * from "./Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports